import type { IMenuItemLayout } from "@/api/interfaces/menuLayout";
import type { TermsOfServiceStatus } from "@/api/interfaces/userLayouts";
import { hasAcceptedTerms } from "@/base/utils/userUtil";
import config from "@/constants/config";

const filterMenuItems = (
  items: IMenuItemLayout[],
  isAuthenticated: boolean,
): IMenuItemLayout[] => {
  if (isAuthenticated)
    return items.filter((item) => item.visibleForAuthenticated);
  if (config.routerConfig.routerMode === "giftCard")
    return items.filter((item) => item.visibleInGiftCardDomain);
  return items.filter((item) => item.visibleForAnonymous);
};

const isMenuItemDisabled = (
  shouldDisableWhenNotValidated: boolean,
  termsStatus?: TermsOfServiceStatus,
): boolean => {
  if (termsStatus) {
    return shouldDisableWhenNotValidated && !hasAcceptedTerms(termsStatus);
  }
  return false;
};

export { filterMenuItems, isMenuItemDisabled };
